import React, { useRef } from 'react';
import { Badge, Button, Popconfirm } from 'antd';
import { DeleteOutlined, ReloadOutlined, ClearOutlined, PlusOutlined } from '@ant-design/icons';
import { isEmpty } from 'lodash';

const ActionBar = ({ data, currentDataSource, selectedRowKeys, onRefresh, hasFilters, clearAllFilters, onAdd, onDelete }) => {
  const btnRefresh = useRef(null);
  const btnClearAllFilters = useRef(null);
  const btnAdd = useRef(null);
  const btnDelete = useRef(null);
  return (
    <div style={{ ...styles.container, position: isEmpty(data) || isEmpty(currentDataSource) ? 'relative' : 'absolute' }}>
      <Button ref={btnRefresh} icon={<ReloadOutlined />} style={styles.actionButton} onClick={() => { onRefresh(); btnRefresh.current.blur(); }}>Refresh</Button>
      <Button ref={btnClearAllFilters} icon={<ClearOutlined />} type={hasFilters ? 'primary' : 'default'} style={styles.actionButton} onClick={() => { clearAllFilters(); btnClearAllFilters.current.blur(); }}>Clear all filters</Button>
      <Button ref={btnAdd} icon={<PlusOutlined style={{ color: 'white' }} />} style={{ ...styles.actionButton, backgroundColor: '#28a745', color: 'white' }} onClick={() => { onAdd(); btnAdd.current.blur(); }}>Add</Button>
      <Popconfirm
        title="Are you sure to delete selected items?"
        onConfirm={() => {
          onDelete(selectedRowKeys);
          btnDelete.current.blur();
        }}
        okText="Yes"
        cancelText="No"
      >
        <Badge count={selectedRowKeys.length} style={{ zIndex: 999 }}>
          <Button ref={btnDelete} icon={<DeleteOutlined />} type='primary' danger style={{ ...styles.actionButton, }}
          >Delete
          </Button>
        </Badge>
      </Popconfirm>
    </div >
  )
}

const styles = {
  container: {
    height: 64,
    display: 'flex',
    alignItems: 'center'
  },
  actionButton: {
    borderRadius: 5,
    zIndex: 99,
    marginRight: 10
  }
};

export default ActionBar;